/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PaymentProviderCaptureMethod/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Content from './Content/index'
import Error from './Error/index'
import Loading from './Loading/index'
import No from './No/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function PaymentProviderCaptureMethod({
  children,
  amount,
  method,
  person,
  onPaymentPageCallback,
  reusableForBluefin,
  viewPath = "/DesignSystem/PaymentProvider/PaymentProviderCaptureMethod",
  marginTop = 0,
  marginBottom = 0
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let paymentStateValueData = fromData.useDataFormat({ viewPath,
context: 'payment',
path: 'state',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: paymentStateValueData,
})
  return (<React.Fragment
>
<div
  data-testid="PaymentProviderCaptureMethod.Vertical"
  data-view-path={viewPath}
 style={{'--mt-1-r1soI': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-2-r1soI': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom}}
 className={`views-block ${styles.Vertical}`}
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Loading'}>
<Loading
  viewPath={`${viewPath}/Loading`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Error'}>
<Error
  viewPath={`${viewPath}/Error`}
 method={method}
 person={person}
/>
</fromFlow.When>
</div>
{children}
</React.Fragment>)
}